import { render, staticRenderFns } from "./SubCertificateCell.vue?vue&type=template&id=731350be"
import script from "./SubCertificateCell.vue?vue&type=script&lang=js"
export * from "./SubCertificateCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports